var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8091 13.395C19.5141 11.978 20.6991 9.95299 20.9921 7.62399C21.0611 7.07699 20.6731 6.57699 20.1241 6.50799C19.5841 6.43399 19.0761 6.82699 19.0081 7.37499C18.5691 10.867 15.5561 13.5 12.0001 13.5C8.44407 13.5 5.43107 10.867 4.99207 7.37499C4.92407 6.82699 4.41407 6.43799 3.87507 6.50799C3.32707 6.57699 2.93907 7.07699 3.00807 7.62399C3.30107 9.95299 4.48607 11.978 6.19107 13.395L3.87907 15.707C3.49007 16.096 3.49007 16.732 3.87907 17.121C4.26707 17.51 4.90407 17.51 5.29307 17.121L7.89607 14.518C8.85007 15 9.89707 15.318 11.0001 15.439V19C11.0001 19.55 11.4501 20 12.0001 20C12.5501 20 13.0001 19.55 13.0001 19V15.439C14.1021 15.318 15.1501 15 16.1031 14.518L18.7071 17.121C19.0961 17.51 19.7321 17.51 20.1211 17.121C20.5101 16.732 20.5101 16.096 20.1211 15.707L17.8091 13.395Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff2);
export default __webpack_public_path__ + "static/media/eye-off2.73d435eb049021420bfdf7ad4e519a8e.svg";
export { ForwardRef as ReactComponent };